import { KlaviyoPopupAdapter } from '@/components/popup-logic/adapters/klaviyo';
import { Popup } from '@/components/popup-logic/popup';

type KlaviyoIDs = {
  displayName: string;
  desktop: string;
  mobile: string;
};

export default function addDefinitions(): boolean {
  try {
    const vendor = window?.PDP?.productData?.vendor?.toLowerCase?.() ?? '';
    let isMedispaPage = false;
    if (
      document.body.classList.contains('template-medispa-v2') ||
      document.body.classList.contains('medispa-lp') ||
      vendor.includes('medispa')
    ) {
      isMedispaPage = true;
    }

    // Don't show on Medispa pages
    if (isMedispaPage) {
      return false;
    }

    // Map of popup IDs to their desktop and mobile variants
    // Key is the market code (e.g. "zh-hans", "en"). "default" is used as a fallback
    const klaviyoFormMap = new Map<string, KlaviyoIDs>([
      [
        'default',
        {
          displayName: 'Multi-step email & SMS & Countdown',
          desktop: 'UBRZB9',
          mobile: 'WPCafj',
        },
      ],
    ]);

    const currentMarket = window.Shopify.routes.root.replace(/\//g, '');

    let klaviyoID = klaviyoFormMap.get(currentMarket) || klaviyoFormMap.get('default')!;

    // After all those checks are done, if the popup config has been overridden, use those IDs instead

    if (typeof window.offerPopupConfig?.override_source !== 'undefined') {
      klaviyoID.desktop = window.offerPopupConfig.desktop;
      klaviyoID.mobile = window.offerPopupConfig.mobile;
    }

    const deviceType = matchMedia('(pointer: fine)').matches ? 'desktop' : 'mobile';

    const adapter = new KlaviyoPopupAdapter({ id: klaviyoID[deviceType] });
    const popup = new Popup(adapter, {
      id: klaviyoID[deviceType],
      displayName: klaviyoID.displayName,
    });

    window.popupMonitor.addPopup(popup);

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}
